import {SmartComponent} from "smart-component-js";
import AdvancedSearchPanel from "../utils/AdvancedSearchPanel";

class AdvancedSearchComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.advancedSearchElement = this.element.querySelector('.advanced-search-panel');
        this.searchButton = this.element.querySelector('.advanced-search-bar__button');
        this.advancedSearchButton = this.element.querySelector('.search-ingridient__button');
        this.advancedSearchInput = this.element.querySelector('.advanced-search-bar__input');
        this.init();
    }

    addSearchListener() {
        this.searchButton?.addEventListener('click', () => this.search());
        this.advancedSearchButton?.addEventListener('click', () => this.search());
    }


    getQueryParams(filters) {
        let params = [];
        Object.keys(filters).forEach((key) => {
            const value = filters[key];
            if(value) params.push(`${key}=${value}`);
        });
        return params.join('&');
    }


    search() {
        let filters = this.advancedSearch.getActiveFilters();
        filters.keyword = this.advancedSearchInput.value || '';
        window.location.href = `${GENERIC_TRANSLATIONS.recipeSearchLink}?${ this.getQueryParams(filters) }`;
    }

    init() {
        this.advancedSearch = new AdvancedSearchPanel(this.advancedSearchElement);
        this.addSearchListener();
    }
}

export default AdvancedSearchComponent;
